import { NavMenuCategory, NavMenuSubcategory, Permissions, UserSettingKeys } from "@/lib/utilities/enums";

function initialState() {
  return {
    NavMenuFilter: {
      Category: null, //NavMenuCategory.ManagerDashboard,
      Subcategory: []
    },
    EnableHorizontalMenu: false
  };
}

const state = initialState();

function hasPermission(user, permissionId) {
  if (
    !user ||
    !user.Permissions ||
    user.Permissions.length === 0 ||
    permissionId <= 0
  ) {
    return false;
  }

  let permissionCode = getPermissionCode(permissionId);

  return permissionCode && user.Permissions.indexOf(permissionCode) >= 0;
}

function generateMainMenu({
  id,
  name,
  activeIcon,
  inactiveIcon,
  subcategories,
  sortOrder
}) {
  return {
    Id: id,
    Name: name,
    ActiveIcon: activeIcon,
    InactiveIcon: inactiveIcon,
    Subcategories: subcategories,
    sortOrder: sortOrder
  };
}

function generateMenuItems(accessInfo) {
  let menuItems = [];
  let subcategories = [];

  // CUSTOMER SEARCH
  // if (accessInfo.ilmEnabled) PX-13066
  menuItems.push(
    generateMainMenu({
      id: NavMenuCategory.ContactSearch,
      name: "Customer Search",
      subcategories: [],
      activeIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-customer-search-vanilla.svg`,
      inactiveIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-customer-search-ocean-deep.svg`,
    })
  );

  // DASHBOARDS
  subcategories = [];

  if (hasPermission(accessInfo.user, Permissions.ManagerDashboard))
    subcategories.push({
      Id: NavMenuSubcategory.ManagerDashboard,
      Name: "Manager"
    });

  if (accessInfo.bdcEnabled && hasPermission(accessInfo.user, Permissions.BDCDashboard))
    subcategories.push({
      Id: NavMenuSubcategory.BDCDashboard,
      Name: "BDC"
    });

  subcategories.push({
    Id: NavMenuSubcategory.SalesDashboard,
    Name: "Sales"
  });

  menuItems.push(
    generateMainMenu({
      id: NavMenuCategory.Dashboards,
      name: "Dashboards",
      subcategories: subcategories,
      activeIcon: `https://assets.autoalert.com/img/autoalert-icons/icon-dashboard-vanilla.svg`,
      inactiveIcon: `https://assets.autoalert.com/img/autoalert-icons/icon-dashboard-oceandeep.svg`,
    })
  );

  // CXM LOGS
  subcategories = [];

  if (accessInfo.ilmEnabled && accessInfo.hasLeadSettings)
    subcategories.push({
      Id: NavMenuSubcategory.LeadsDashboard,
      Name: "Leads Log"
      // subcategories: accessInfo.leadsLogSavedSearches    // TODO: Move this to Leads Log page
    });

  if (accessInfo.ilmEnabled && accessInfo.showroomEnabled)
    subcategories.push({
      Id: NavMenuSubcategory.ShowroomDashboard,
      Name: "Showroom Log"
    });

  if (accessInfo.ilmEnabled && accessInfo.deliveryEnabled)
    subcategories.push({
      Id: NavMenuSubcategory.DeliveryDashboard,
      Name: "Delivery Log"
    });

  if (accessInfo.callTrackingEnabled)
    subcategories.push({
      Id: NavMenuSubcategory.CallTrackingDashboard,
      Name: "Call Log"
    });

  if (subcategories.length > 0)
    menuItems.push(
      generateMainMenu({
        id: NavMenuCategory.CXMLogs,
        name: "CXM Logs",
        subcategories: subcategories,
        activeIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-leads-vanilla.svg`,
        inactiveIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-leads-ocean-deep.svg`,
      })
    );

  // DATA MINING
  subcategories = [
    {
      Id: NavMenuSubcategory.OpportunitiesDashboard,
      Name: "Opportunities"
    },
    {
      Id: NavMenuSubcategory.OpportunitiesSearch,
      Name: "Opportunities Search"
    },
    {
      Id: NavMenuSubcategory.PriorityOpportunities,
      Name: "Priority Opportunities"
    }
  ];

  // if (hasPermission(accessInfo.user, Permissions.UnmatchedDMSSales))
  //   subcategories.push({
  //     Id: NavMenuSubcategory.UnmatchedDMSSales,
  //     Name: "Unmatched DMS Sales"
  //   });

  menuItems.push(
    generateMainMenu({
      id: NavMenuCategory.DataMining,
      name: "Data Mining",
      subcategories: subcategories,
      activeIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-data-mining-vanilla.svg`,
      inactiveIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-data-mining-oceandeep.svg`,
    })
  );

  // SERVICE
  subcategories = [];

  if (accessInfo.slmEnabled && hasPermission(accessInfo.user, Permissions.SLMDashboardManager)) {
    subcategories.push({
      Id: NavMenuSubcategory.SLMDashboard,
      Name: "SLM Dashboard"
    });

    if (hasPermission(accessInfo.user, Permissions.OperatorPanelAdmin))
      subcategories.push({
        Id: NavMenuSubcategory.OperatorsPanel,
        Name: "SLM Operators"
      });
  }

  subcategories.push(
    {
      Id: NavMenuSubcategory.ServiceExperience,
      Name: "Service Experience"
    });

  menuItems.push(
    generateMainMenu({
      id: NavMenuCategory.ServiceExperience,
      name: "Service",
      subcategories: subcategories,
      activeIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-engagement-service-vanilla.svg`,
      inactiveIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-engagement-service-oceandeep.svg`,
    })
  );

  // INVENTORY
  subcategories = [
    {
      Id: NavMenuSubcategory.InventorySearch,
      Name: "All Inventory"
    }
  ];

  if (hasPermission(accessInfo.user, Permissions.WishlistManager))
    subcategories.push({
      Id: NavMenuSubcategory.InventoryWishlist,
      Name: "Wishlist"
    });

  menuItems.push(
    generateMainMenu({
      id: NavMenuCategory.Inventory,
      name: "Inventory",
      subcategories: subcategories,
      activeIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-inventory-wishlist-vanilla.svg`,
      inactiveIcon: `https://stage-assets.autoalert.com/img/autoalert-icons/icon-inventory-wishlist-oceandeep.svg`,
    })
  );

  // REPORTS
  // Add Reports menu if the user has any of the tableau permissions
  if (accessInfo.reportsEnabled && (accessInfo.user.Permissions || []).some(perm => perm.startsWith("pando.analytics.tableau.")))
    menuItems.push(
      generateMainMenu({
        id: NavMenuCategory.Reports,
        name: "Reports",
        subcategories: accessInfo.tableauFavoriteViews,
        activeIcon: `https://assets.autoalert.com/img/autoalert-icons/icon-AO-reports-vanilla.svg`,
        inactiveIcon: `https://assets.autoalert.com/img/autoalert-icons/icon-AO-reports-oceandeep.svg`,
      })
    );

  // WORKFLOW MANAGER
  if (hasPermission(accessInfo.user, Permissions.RulesAdministration) || hasPermission(accessInfo.user, Permissions.RulesViewOnly)) {
    menuItems.push(
      generateMainMenu({
        id: NavMenuCategory.RulesAdministration,
        name: "Workflow Manager",
        subcategories: [],
        activeIcon: `https://assets.autoalert.com/img/autoalert-icons/icon-task-builder-vanilla.svg`,
        inactiveIcon: `https://assets.autoalert.com/img/autoalert-icons/icon-task-builder-oceandeep.svg`,
      })
    );
  }

  return menuItems;
}

function getPermissionCode(permissionId) {
  switch (permissionId) {
    case Permissions.ManagerDashboard:
      return "pando.cxm.dashboard.manager";
    case Permissions.BDCDashboard:
      return "pando.cxm.dashboard.bdc";
    case Permissions.RulesAdministration:
      return "pando.cxm.rules.admin";
    case Permissions.RulesViewOnly:
      return "pando.cxm.rules.viewonly";
    case Permissions.UnmatchedDMSSales:
      return "pando.cxm.unmatcheddmssales";
    case Permissions.ManageCallTracking:
      return "pando.cxm.dashboard.calltracking";
    case Permissions.SLMDashboardManager:
      return "pando.cxm.slm.manager";
    case Permissions.OperatorPanelAdmin:
      return "pando.cxm.operatorpanel.admin";
    case Permissions.WishlistManager:
      return "pando.cxm.wishlist.manager";
    default:
      return null;
  }
}

const getters = {
  NavMenuFilter(state) {
    return state.NavMenuFilter;
  },
  NavMenuItems(state, getters, rootState, rootGetters) {
    const accessInfo = {
      user: rootGetters.User,
      bdcEnabled: (rootGetters.BdcStores || []).length > 0,
      showroomEnabled: (rootGetters.ShowroomStores || []).length > 0,
      deliveryEnabled: (rootGetters.DeliveryStores || []).length > 0,
      ilmEnabled: (rootGetters.ILMStores || []).length > 0,
      slmEnabled: (rootGetters.SLMStores || []).length > 0,
      reportsEnabled: (rootGetters.AnalyticsStores || []).length > 0,
      callTrackingEnabled: rootGetters.IsCallTrackingEnabled,
      hasLeadSettings: rootGetters.HasLeadSettings,
      contactSearchSavedSearches: rootGetters.ContactSearchSavedSearches || [],
      leadsLogSavedSearches: rootGetters.LeadsDashboardSavedSearches || [],
      tableauFavoriteViews: rootGetters.TableauFavoriteViews || []
    };

    return generateMenuItems(accessInfo);
  }
};

const actions = {
  updateNavMenuFilter(context, filter) {
    context.commit("updateNavMenuFilter", filter);
  },
  updateMenuPreference(context, data) {
    context.commit("updateMenuPreference", data);
  },
  async getHeaderInfo(context) {
    const response = await context.dispatch("getUserSettings", UserSettingKeys.GLOBAL_FRAME_HEADER_INFO);
    if (response && response.Value) {
      let headerInfo = JSON.parse(response.Value);
      context.commit("updateMenuPreference", headerInfo);
    }
  },
};

const mutations = {
  updateNavMenuFilter(state, filter) {
    state.NavMenuFilter.Category = filter.Category;
    state.NavMenuFilter.Subcategory = filter.Subcategory;
  },
  updateMenuPreference(state, data) {
    state.EnableHorizontalMenu = data.enableHorizontalMenu || false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/SideNav.js